import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#071320] text-slate-300 border-t border-slate-800">
      {/* Top Banner - Combined 2 Columns */}
      <div className="bg-[#1E7BC1] py-12 lg:py-16 border-b border-blue-600/40 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 divide-y lg:divide-y-0 lg:divide-x divide-blue-400/30">
            {/* Col 1: Sælg din båd */}
            <div className="flex flex-col justify-between space-y-5 lg:pr-10">
              <div>
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#2BABE3] font-semibold block mb-2">
                  Tryghed ved bådsalg
                </span>
                <h3 className="text-2xl sm:text-3xl font-serif font-light text-white mb-3">
                  Overvejer du at sælge din båd?
                </h3>
                <p className="text-blue-100 text-xs sm:text-sm font-light leading-relaxed">
                  Vi tilbyder professionel bådformidling i hele Danmark efter princippet{' '}
                  <strong className="text-white font-medium">Solgt eller gratis</strong>. Bliver båden ikke solgt, koster det dig intet.
                </p>
              </div>
              <div className="pt-2">
                <Link
                  to="/saelg-din-baad"
                  className="inline-flex items-center gap-2 border border-[#2BABE3] bg-[#2BABE3] hover:bg-white hover:text-[#1E7BC1] text-white px-6 py-3.5 text-[11px] uppercase tracking-[0.2em] font-semibold transition-all rounded-xl whitespace-nowrap shadow-md"
                >
                  <i className="fa-solid fa-ship text-[10px]" aria-hidden="true" />
                  <span>Sælg din båd her</span>
                </Link>
              </div>
            </div>

            {/* Col 2: Spørgsmål & Fremvisning */}
            <div className="flex flex-col justify-between space-y-5 pt-8 lg:pt-0 lg:pl-10">
              <div>
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#2BABE3] font-semibold block mb-2">
                  Personlig rådgivning
                </span>
                <h3 className="text-2xl sm:text-3xl font-serif font-light text-white mb-3">
                  Har du spørgsmål eller ønsker fremvisning?
                </h3>
                <p className="text-blue-100 text-xs sm:text-sm font-light leading-relaxed">
                  Vi står altid klar til en uforpligtende snak om køb eller salg af båd. Kontakt os gerne i dag.
                </p>
              </div>

              <div className="flex flex-wrap items-center gap-3 pt-2">
                <a
                  href="tel:40207034"
                  className="inline-flex items-center gap-2 border border-white/30 bg-white/10 hover:bg-white hover:text-[#1E7BC1] text-white px-5 py-3 text-[11px] uppercase tracking-[0.2em] font-semibold transition-all rounded-xl whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-[#2BABE3] text-[10px]" aria-hidden="true" />
                  <span className="whitespace-nowrap">Ring 40 20 70 34</span>
                </a>

                <a
                  href="mailto:info@nordfyn-marine.dk"
                  className="inline-flex items-center gap-2 border border-white/30 bg-white/10 hover:bg-white hover:text-[#1E7BC1] text-white px-5 py-3 text-[11px] uppercase tracking-[0.2em] font-semibold transition-all rounded-xl whitespace-nowrap"
                >
                  <i className="fa-solid fa-envelope text-[#2BABE3] text-[10px]" aria-hidden="true" />
                  <span className="whitespace-nowrap">Send e-mail</span>
                </a>

                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 border border-[#071320] bg-[#071320] hover:bg-slate-800 text-white px-5 py-3 text-[11px] uppercase tracking-[0.2em] font-semibold transition-all rounded-xl whitespace-nowrap shadow-md"
                >
                  <span>Kontaktformular</span>
                  <i className="fa-solid fa-arrow-right text-[9px]" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
        {/* Col 1: About */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img
              src="https://assets.auxodev.dk/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/nordfyn-marine-logo.png"
              alt="Nordfyn Marine"
              className="h-14 sm:h-16 md:h-18 w-auto object-contain"
            />
          </div>
          <p className="text-xs text-slate-400 leading-relaxed font-light">
            Nordfyn Marine er din trygge og erfarne bådmægler på Fyn med landsdækkende rækkevidde. Vi sikrer en professionel handel for både køber og sælger.
          </p>
          <div className="pt-2">
            <span className="inline-block text-[10px] uppercase tracking-[0.2em] font-semibold text-[#2BABE3] bg-[#1E7BC1]/20 px-3 py-1.5 border border-[#2BABE3]/30 rounded-full">
              <i className="fa-solid fa-shield-halved mr-1.5 text-[9px]" />
              Solgt eller gratis
            </span>
          </div>
        </div>

        {/* Col 2: Categories */}
        <div className="space-y-4">
          <h4 className="text-[11px] font-semibold text-white uppercase tracking-[0.25em] font-serif border-b border-slate-800 pb-2">
            Bådkategorier
          </h4>
          <ul className="list-none space-y-2.5 text-xs font-light">
            <li>
              <Link to="/baade" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Alle både til salg</span>
              </Link>
            </li>
            <li>
              <Link to="/motorbaade" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Motorbåde</span>
              </Link>
            </li>
            <li>
              <Link to="/motorsejlere" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Motorsejlere</span>
              </Link>
            </li>
            <li>
              <Link to="/sejlbaade" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Sejlbåde</span>
              </Link>
            </li>
            <li>
              <Link to="/forespoergsel" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Send forespørgsel</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Col 3: Navigation */}
        <div className="space-y-4">
          <h4 className="text-[11px] font-semibold text-white uppercase tracking-[0.25em] font-serif border-b border-slate-800 pb-2">
            Genveje
          </h4>
          <ul className="list-none space-y-2.5 text-xs font-light">
            <li>
              <Link to="/om-os" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Om Nordfyn Marine</span>
              </Link>
            </li>
            <li>
              <Link to="/saelg-din-baad" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Sælg din båd</span>
              </Link>
            </li>
            <li>
              <Link to="/forsikring" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Forsikring</span>
              </Link>
            </li>
            <li>
              <Link to="/samarbejdspartnere" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Samarbejdspartnere</span>
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="hover:text-[#2BABE3] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-[#2BABE3]" />
                <span>Kontakt os</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Col 4: Contact info */}
        <div className="space-y-4">
          <h4 className="text-[11px] font-semibold text-white uppercase tracking-[0.25em] font-serif border-b border-slate-800 pb-2">
            Kontakt os
          </h4>
          <div className="space-y-3 text-xs text-slate-300 font-light">
            <p className="font-medium text-white tracking-wide uppercase text-[11px]">Nordfyn Marine</p>
            <p className="flex items-start gap-2.5">
              <i className="fa-solid fa-user text-[#2BABE3] mt-0.5 text-[10px]" aria-hidden="true" />
              <span>Nordfyn Marine</span>
            </p>
            <p className="flex items-center gap-2.5">
              <i className="fa-solid fa-phone text-[#2BABE3] text-[10px]" aria-hidden="true" />
              <a
                href="tel:40207034"
                className="hover:text-[#2BABE3] font-semibold text-white transition-colors whitespace-nowrap"
              >
                40 20 70 34
              </a>
            </p>
            <p className="flex items-center gap-2.5">
              <i className="fa-solid fa-envelope text-[#2BABE3] text-[10px]" aria-hidden="true" />
              <a
                href="mailto:info@nordfyn-marine.dk"
                className="hover:text-[#2BABE3] transition-colors whitespace-nowrap"
              >
                info@nordfyn-marine.dk
              </a>
            </p>
            <p className="flex items-start gap-2.5">
              <i className="fa-solid fa-location-dot text-[#2BABE3] mt-0.5 text-[10px]" aria-hidden="true" />
              <span>Stationsvej 24, 5450 Otterup</span>
            </p>
            <p className="flex items-center gap-2.5">
              <i className="fa-solid fa-id-card text-[#2BABE3] text-[10px]" aria-hidden="true" />
              <span>CVR: 14959335</span>
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Legal bar */}
      <div className="border-t border-slate-800/80 bg-[#040C18] py-5 text-xs text-slate-400">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4 text-center sm:text-left">
          <p className="text-[10px] uppercase tracking-[0.2em]">© {currentYear} NORDFYN MARINE. ALLE RETTIGHEDER FORBEHOLDES.</p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-[11px]">
            <a
              href="https://www.iubenda.com/privacy-policy/89297131"
              className="iubenda-white iubenda-noiframe iubenda-embed text-slate-400 hover:text-[#2BABE3] transition-colors"
              title="Privatlivspolitik "
            >
              Privatlivspolitik
            </a>
            <span className="text-slate-700">·</span>
            <a
              href="https://www.iubenda.com/privacy-policy/89297131/cookie-policy"
              className="iubenda-white iubenda-noiframe iubenda-embed text-slate-400 hover:text-[#2BABE3] transition-colors"
              title="Cookiepolitik "
            >
              Cookiepolitik
            </a>
          </div>
          <p className="text-slate-400 text-[10px] uppercase tracking-[0.2em]">
            PROFESSIONEL BÅDFORMIDLING · SOLGT ELLER GRATIS
          </p>
        </div>
      </div>
    </footer>
  )
}
